import React from 'react';

export default function SpamPermission({hidden, children}) {
    return <span hidden={hidden}>{children}</span>
}
